
import { toast } from "sonner";

export const handleDatabaseError = (error: any, customMessage?: string) => {
  console.error("Database error:", error);
  
  if (error.code === "PGRST301") {
    console.log("Session expired, refreshing...");
    toast.error("Session expired. Please try again.");
  } else {
    toast.error(customMessage || error.message || "An unexpected error occurred");
  }
  
  throw error;
};
